const React = require("react");
const Link = require("../../core/view/Link");

const getTeacherCopy = function(styles, options = {}) {
	return [
		{
			hash: "overview",
			title: "Welcome to Beast Academy!",
			titleLevel: 1,
			contents: (
				<div className={styles.rowContainerNoTOC}>
					<div className={styles.columnCentered}>
						<div className={styles.overviewText}>
							<b>
								Beast Academy will help your students build a solid mathematical
								foundation and hone their problem-solving skills.
							</b>{" "}
							You won't find any mindless algorithms here; instead, we provide a
							conceptual approach delivered from people who really know math. We
							promise to challenge all of your students, even the ones who seem
							to get every question correct!
						</div>
					</div>
				</div>
			),
		},
		{
			hash: "welcome-to-ba",
			contents: (
				<div>
					<p>
						Here is how we recommend you familiarize yourself with BA Online.
					</p>
					<ol>
						<li className={styles.listItem}>
							<b>
								Play BA Online yourself by clicking the blue PLAY button on the
								upper right of this page.
							</b>
							<br />
							<p className={styles.listItemText}>
								Read the Guide book, watch a few videos, and answer some
								questions. You might find yourself getting stumped - that's a
								good thing! Students need to see their teachers genuinely
								solving tough problems with them rather than repeatedly and
								perfectly answering the same types of questions.
							</p>
						</li>
						<li className={styles.listItem}>
							<b>Check out the support pages here.</b>
							<br />
							<p className={styles.listItemText}>
								We recommend watching the quick videos at the top of each tab
								and skimming each page (it's not necessary to read all the
								words; instead, think of these Support pages as a reference you
								can use as needed).
							</p>
							<ul>
								<li>
									The{" "}
									<Link
										to={options.supportLinkURL("play")}
										className={styles.link}
									>
										Play
									</Link>{" "}
									tab explains the student side of BA Online.
								</li>
								<li>
									The{" "}
									<Link
										to={options.supportLinkURL("reports")}
										className={styles.link}
									>
										Reports
									</Link>{" "}
									tab discusses tools for monitoring your students' progress.
								</li>
								<li>
									The{" "}
									<Link
										to={options.supportLinkURL("accounts")}
										className={styles.link}
									>
										Accounts
									</Link>{" "}
									tab shows how to set up your class.
								</li>
								<li>
									The{" "}
									<Link
										to={options.supportLinkURL("planning")}
										className={styles.link}
									>
										Planning
									</Link>{" "}
									tab contains helpful teacher resources.
								</li>
							</ul>
						</li>
						<li className={styles.listItem}>
							<b>Decide how you want your students to start.</b>
							<br />
							<p className={styles.listItemText}>
								We recommend that students new to Beast Academy begin at a level
								that is at least 1 less than their grade in school. This will
								allow them to get used to the challenge level of Beast Academy,
								and they can move ahead quickly if things are going well.
								<br />
								Beast Academy has over 1,000 lessons. While it's best to work
								through lessons in order, students do not have to master every
								lesson before moving on. The monster icon indicates enrichment
								lessons that go beyond what is typically taught in most
								classrooms. Enrichment lessons may be considered optional and
								are great for students who could use an extra challenge or want
								to learn a new topic.
							</p>
						</li>
					</ol>
					<p>
						Thanks for reading. We hope you love Beast Academy as much as we do!
					</p>
				</div>
			),
		},
	];
};

module.exports = {
	getTeacherCopy,
};
